export type Pivot<T> = {
    [P in keyof T]: Array<T[P]>;
};

/**
 * Reorganize table from `[ROW][COLUMN]` into `[COLUMN][ROW]`
 * @param table 
 * @returns 
 */
export function pivotTable<Type>(table: Type[]) : Pivot<Type> {
    return table.reduce((pivoted: any, record) => {
        for (var key in record) {
            if (!pivoted[key]) {
                pivoted[key] = [];
            }
            pivoted[key].push(record[key]);
        }
        return pivoted;
    }, {})
}